import React from 'react';

const TIER_ROWS = [
  { range: '$1 – $9.99', a: '35% Cash / 50% Credit', b: '30% Cash / 45% Credit', c: '25% Cash / 40% Credit' },
  { range: '$10 – $49.99', a: '45% Cash / 65% Credit', b: '40% Cash / 60% Credit', c: '35% Cash / 55% Credit' },
  { range: '$50 – $199.99', a: '50% Cash / 70% Credit', b: '45% Cash / 65% Credit', c: '40% Cash / 60% Credit' },
  { range: '$200+', a: '60% Cash / 80% Credit', b: '55% Cash / 75% Credit', c: '50% Cash / 70% Credit' },
];

const GAME_TIERS = [
  { tier: 'Tier A', games: ['Magic: The Gathering', 'Pokémon', 'Pokémon Japan', 'Yu-Gi-Oh!', 'One Piece', 'Riftbound', 'Gundam'] },
  { tier: 'Tier B', games: ['Lorcana', 'Star Wars Unlimited', 'Dragon Ball Super Fusion World', 'Union Arena', 'Cardfight!! Vanguard'] },
  { tier: 'Tier C', games: ['Flesh and Blood', 'Cyberpunk TCG', 'Palworld', 'CookieRun Braverse'] },
];
const GAME_ROWS = Math.max(...GAME_TIERS.map((t) => t.games.length));

const REQUIREMENTS = [
  'English-language slabs only: PSA, BGS, CGC, and SGC.',
  'Separate bulk from higher-value cards when possible.',
  'Remove cards from binders, deck boxes, and sleeves.',
  'No damaged, heavily played, counterfeit, altered, or most foreign-language cards.',
];

const Heading = ({ children }) => (
  <h2 className="text-sm font-bold uppercase tracking-wide text-[#2F5F92] mt-8 mb-3">{children}</h2>
);

const TradePolicy = () => (
  <div className="min-h-screen bg-gray-50 pt-24 pb-12">
    <div className="container max-w-4xl text-[#1F1F1F]">
      <h1 className="text-3xl font-bold text-[#17365D] border-b-2 border-[#4F81BD] pb-2 mb-4">
        Next Level Games - Trade Policy
      </h1>
      <p className="mb-2">
        Our goal is to offer fair, transparent trade values based on current market prices, condition, and demand.
        All singles rates are based on current TCGPlayer Market pricing.
      </p>

      <Heading>Singles Trade-In Tiers</Heading>
      <p className="mb-3">
        Rates now vary by game tier. The card's market value determines the row, and the game's tier determines the
        cash/store-credit rate.
      </p>
      <div className="overflow-x-auto">
        <table className="w-full text-sm text-center border-collapse">
          <thead>
            <tr className="bg-[#D9EAF7] font-bold">
              {['Card Market Value', 'Tier A', 'Tier B', 'Tier C'].map((h) => (
                <th key={h} className="border border-[#B7C9D6] px-3 py-2">{h}</th>
              ))}
            </tr>
          </thead>
          <tbody>
            {TIER_ROWS.map((r) => (
              <tr key={r.range}>
                <td className="border border-[#B7C9D6] px-3 py-2 font-bold">{r.range}</td>
                <td className="border border-[#B7C9D6] px-3 py-2">{r.a}</td>
                <td className="border border-[#B7C9D6] px-3 py-2">{r.b}</td>
                <td className="border border-[#B7C9D6] px-3 py-2">{r.c}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>

      <Heading>Game Tiers</Heading>
      <table className="w-full text-sm text-left bg-[#F2F2F2]">
        <thead>
          <tr>
            {GAME_TIERS.map(({ tier }) => (
              <th key={tier} className="w-1/3 px-3 pt-2 pb-1 font-bold text-[#2F5F92]">{tier}</th>
            ))}
          </tr>
        </thead>
        <tbody>
          {Array.from({ length: GAME_ROWS }, (_, i) => (
            <tr key={i}>
              {GAME_TIERS.map(({ tier, games }) => (
                <td key={tier} className="px-3 py-0.5 align-top">{games[i] || '\u00A0'}</td>
              ))}
            </tr>
          ))}
        </tbody>
      </table>
      <p className="mt-3">
        <strong>Cards Under $1: </strong>Not individually priced. Eligible bulk may be traded at $5 per 1,000 cards
        in Store Credit
      </p>

      <Heading>Premium Singles Trade Rates</Heading>
      <p><strong>Reserved List &amp; High-End Magic</strong> - Dual Lands, Power, etc.</p>
      <p><strong>High-End Pokémon Singles &amp; Slabs</strong> - Bubble Mew, Ponchos, Base Set Charizard, etc.</p>
      <p className="mt-4 font-bold">85% Store Credit • 70% Cash</p>

      <Heading>Sealed Product Rates</Heading>
      <p>
        <strong>Standard Sealed:</strong> Sealed products from current releases with typical availability and demand.
      </p>
      <p className="font-bold mb-4">70% Store Credit • 55% Cash</p>
      <p>
        <strong>Priority Sealed:</strong> Sealed products with strong demand, limited availability, or high inventory
        priority.
      </p>
      <p className="font-bold mb-4">85% Store Credit • 70% Cash</p>
      <p className="italic">Final offers depend on condition, demand, and market trends.</p>

      <Heading>Requirements</Heading>
      <ul className="space-y-1">
        {REQUIREMENTS.map((r) => <li key={r}>• {r}</li>)}
      </ul>
      <p className="mt-4">
        Store Credit is issued as loyalty points (50 points = $1) and may be used on any purchase.
      </p>
      <p className="mt-4">Questions? Just ask! We're always happy to explain how we arrived at an offer.</p>
    </div>
  </div>
);

export default TradePolicy;
